import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/auth';
import { FiLogOut } from 'react-icons/fi';
import '../styles/Header.scss';
import logotext from '../assets/logotext.png'

const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
         
            <img src={logotext} alt="Invits" className="header-logo" />
        </Link>
        
        <nav className="header-nav">
          {user ? (
            <button onClick={handleSignOut} className="btn btn-ghost">
              <FiLogOut />
              Sign Out
            </button>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost">Sign In</Link>
              <Link to="/signup" className="btn btn-primary">Get Started</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
